




































































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FetchState,
  RevealPersonalInformationRequest,
  RevealType,
  InvestmentCustodian,
} from "@/shared/types";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import moment from "moment";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import {
  EmailHistory
} from "@/employer/route-names";
import { Location } from "vue-router";
import * as SharedRoutes from "@/shared/route-names";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useUserInvestmentAccountStore } from "@/shared/store/userInvestmentAccount";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRevealPersonalInformationStore } from "@/shared/store/revealPersonalInformation";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useThemeStore } from "@/shared/store/theme";
import { useUserIdpInformationStore } from "@/employer/store/userIdpInformation";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";

import { useOpenSearchIndexStore } from "@/admin/store/openSearchIndex";
@Component({
  components: {
    GenericLoadingSpinner,
    Button,
    ErrorSummary,
  }
})
export default class AccountHolderProfile extends Vue {
  $validator: Validator;
  contactInfoStore = useContactInfoStore();
  userBankAccountStore = useUserBankAccountStore();
  userInvestmentAccountStore = useUserInvestmentAccountStore();
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  revealStore = useRevealPersonalInformationStore();
  drivewealthStore = useDrivewealthStore();
  themeStore = useThemeStore();
  userIdpInformationStore = useUserIdpInformationStore();
  featureFlagStore = useFeatureFlagStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  openSearchIndexStore = useOpenSearchIndexStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  editModeIsActive = false;
  EmailHistory = EmailHistory;
  SharedRoutes = SharedRoutes;
  formatMMddyyyyDateString = formatMMddyyyyDateString;

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  custodianDisplayName = custodianDisplayName;

  mounted () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userBankAccountStore.loadBankAccountState(args);
    this.userInvestmentAccountStore.loadInvestmentAccount(args);
    this.contactInfoStore.getContactInformation(args);
    this.drivewealthStore.loadAccounts(args);
    this.userBankAccountStore.loadHsaAccounts(args);
    this.investmentThresholdStore.loadInvestmentThresholds(args);
    this.drivewealthSweepStore.getSweep(args);
  }

  @Prop()
  canEditProfile: boolean;
  emailForm = "";
  isUpdatingEmail = false;

  onClickEditMode () {
    this.emailForm = this.email;
    this.editModeIsActive = !this.editModeIsActive;
  }

  get canSaveEdit (): boolean {
    return this.emailForm !== this.email && !this.$validator.errors.has("email");
  }

  routeToInvestmentsV2 (dwAccountId: number): Location {
    const query = (this.username) ? { username: this.username } : undefined;
    return {
      name: SharedRoutes.DrivewealthInvestmentAccountV2,
      params: { accountId: `${dwAccountId}`, partnerId: `${this.partnerId}` },
      query
    };
  }

  onClickSaveEdit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isUpdatingEmail = true;
      this.contactInfoStore.updateUserEmail(
        { username: this.username, email: this.emailForm, partnerId: this.partnerId }).then(res => {
          if (res) {
            this.editModeIsActive = !this.editModeIsActive;
            const args = { username: this.username, partnerId: this.partnerId };
            this.contactInfoStore.getContactInformation(args);
            this.userIdpInformationStore.getProfile({ partnerId: this.partnerId, username: this.username, force: true });
          }
        }).finally(() => {
          this.isUpdatingEmail = false;
        });
    });
  }

  onClickCancelEdit () {
    this.editModeIsActive = false;
    this.emailForm = this.email;
  }
  onReindex () {
    this.openSearchIndexStore.reindexUser(this.username);
  }
  get ssn (): string {
    if (!this.contactInfoStore.contactInformation.lastFourSsn) return "###-##-####";
    return `###-##-${this.contactInfoStore.contactInformation.lastFourSsn}`;
  }

  get memberNumber (): string {
    return this.contactInfoStore.contactInformation.memberNumber;
  }

  get lastName () {
    return this.contactInfoStore.contactInformation.lastName;
  }

  get firstName () {
    return this.contactInfoStore.contactInformation.firstName;
  }

  get email () {
    return this.contactInfoStore.contactInformation.email;
  }

  get phoneNumber () {
    return this.contactInfoStore.contactInformation.phoneNumber;
  }

  get mobilePhoneNumber () {
    return this.contactInfoStore.contactInformation.mobilePhoneNumber;
  }

  get physicalAddress (): any {
    return this.contactInfoStore.contactInformation.physicalAddress;
  }

  get mailingAddress (): any {
    return this.contactInfoStore.contactInformation.mailingAddress;
  }

  get isMailingSameAsPhysical () {
    return this.contactInfoStore.contactInformation.isMailingSameAsPhysical;
  }

  get dateOfBirth () {
    return moment(this.contactInfoStore.contactInformation.dateOfBirth).format("MMMM DD, YYYY");
  }

  get isLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded &&
      this.contactInfoStore.contactInformationState === FetchState.Loaded &&
      this.investmentThresholdStore.thresholdsLoaded &&
      this.drivewealthStore.accountsLoaded &&
      this.userBankAccountStore.hsaAccountsLoaded &&
      !this.isUpdatingEmail;
  }

  revealType: RevealType = RevealType.SocialSecurityNumber;
  reasonComment: string = null;
  showRevealModal = false;

  showModelSsn () {
    this.revealType = RevealType.SocialSecurityNumber;
    this.showRevealModal = true;
  }

  confirmRevealModal () {
    this.$validator.validate().then(isValid => {
      if (!isValid) {
        return;
      }
      this.showRevealModal = false;
      const revealFormModel: RevealPersonalInformationRequest = {
        reason: this.reasonComment,
        revealType: this.revealType,
        revealForUserName: this.username
      };
      this.revealStore.revealPersonalInformation(revealFormModel).then()
        .catch(err => {
          if (err && err.message) {
            this.notifierStore.setDanger(err.message);
          }
        });
    });
  }

  hideModalAndStopEdit () {
    this.showRevealModal = false;
    this.reasonComment = null;
  }

  get displayTDAInvestmentAccount () {
    return this.userInvestmentAccountStore.investmentAccountNumber !== undefined;
  }

  get showRevealSsn () {
    return this.userStore.hasRevealAccess;
  }

  get revealedInfo () {
    return this.revealStore.revealedInformation;
  }

  @Watch("revealedInfo")
  onSensitiveInformationChange () {
    this.reasonComment = null;
    if (this.revealStore.revealedInformation && this.revealStore.revealedInformation.sensitiveInformation) {
      this.notifierStore.setSuccess(
        `${this.revealStore.revealedInformation.revealType} for ${this.firstName} ${this.lastName} is ${this.revealStore.revealedInformation.sensitiveInformation}`);
      this.revealStore.finishedViewingInformation();
    }
  }

  @Watch("investmentThresholdStore.investmentProvider")
  loadDrivewealthIfNeeded () {
    if (!this.investmentThresholdStore.isDrivewealthInvestmentProvider) {
      return;
    }
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({
        username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
      });
    }
  }

  disableSweep (): void {
    const args = { username: this.username, partnerId: this.partnerId };

    this.drivewealthSweepStore.pauseSweepEmployerManagement(args);
  }
}
